import { Theme } from '@mui/material';
import {
  getSidenavBackgroundColor,
  getSidenavBorderColor,
  getSidenavTextColor,
  isSidenavLightSurface,
} from './sidenav-colors';
import { SIDENAV_TOKENS } from './sidenav-tokens';

/** Horizontal gap between the sidenav edge and flyout panels. */
const SIDENAV_POPOVER_OFFSET_X = 6;

const DRAWER_PAPER_SELECTOR = '.MuiDrawer-paper';

/**
 * Viewport position for a flyout that opens to the right of the permanent sidenav drawer.
 * Uses the drawer paper's right edge so the panel stays beside the sidebar, not the trigger.
 */
export function getSidenavSidebarPopoverPosition(triggerEl: HTMLElement) {
  const drawerPaper = triggerEl.closest(DRAWER_PAPER_SELECTOR);
  if (!drawerPaper) {
    return null;
  }

  const drawerRect = drawerPaper.getBoundingClientRect();
  const triggerRect = triggerEl.getBoundingClientRect();

  return {
    top: triggerRect.top,
    left: drawerRect.right + SIDENAV_POPOVER_OFFSET_X,
  };
}

/**
 * MUI Popover root styles for collapsed-rail flyouts (nav hover menus).
 * pointerEvents:none on the root lets the cursor leave the trigger without closing early.
 */
export function getSidenavFlyoutPopoverSx() {
  return {
    pointerEvents: 'none' as const,
    '& .MuiPaper-root': {
      pointerEvents: 'auto',
      backgroundColor: getSidenavBackgroundColor,
      color: getSidenavTextColor,
      marginLeft: `${SIDENAV_POPOVER_OFFSET_X}px`,
      minWidth: SIDENAV_TOKENS.drawerWidth,
      border: (theme: Theme) =>
        isSidenavLightSurface(theme) ? `1px solid ${getSidenavBorderColor(theme)}` : 'none',
      boxShadow: (theme: Theme) =>
        isSidenavLightSurface(theme)
          ? '0px 8px 20px rgba(0, 0, 0, 0.12)'
          : '0px 10px 25px rgba(0, 0, 0, 0.3)',
    },
  };
}
